export default __webpack_public_path__ + "static/media/majid.bce07b48.png";